const testDomains = [
  'app',
  'localhost',
  'verify.8dev.lol',
  'verify.test.8dev.lol',
  'verify.test.immersve.com',
];

export class EnvironmentInfo {
  location: Location;

  constructor({ location }: { location: Location }) {
    this.location = location;
  }

  isTestDomain() {
    return testDomains.includes(this.location.hostname);
  }

  useInTestEnvironmentOtherwiseUseFallback<T>(cb: T, fallback: T): T {
    if (this.isTestDomain()) {
      return cb;
    }
    return fallback;
  }

  useInTestEnvironmentOtherwiseFalse(cb: boolean): boolean {
    return this.useInTestEnvironmentOtherwiseUseFallback(cb, false);
  }

  useInTestEnvironmentOtherwiseTrue(cb: boolean): boolean {
    return this.useInTestEnvironmentOtherwiseUseFallback(cb, true);
  }
}

export const Environment = new EnvironmentInfo({ location: window.location });
